import InsurancePageTemplate from "@/components/InsurancePageTemplate";

export const config = {
  providerName: "United Airlines Microsoft Employee Plan",
  shortName: "UA MS Employee Plan",
  slug: "ua-ms-employee-plan-insurance",
  seoTitle: "UA MS Employee Plan TMS Coverage | Neuro Wellness TMS",
  seoDescription:
    "Have the UA MS Employee Plan? Learn about TMS therapy, SAINT TMS, and depression treatment options that may be available through your United Airlines Microsoft employee plan in Coral Springs, FL.",
  seoKeywords:
    "UA MS Employee Plan TMS coverage, United Airlines Microsoft TMS therapy, UA MS Employee Plan depression treatment Florida, UA MS mental health benefits Coral Springs FL, UA MS Employee Plan SAINT TMS",
  planType: "employer-sponsored health insurance plan",
  planRegion: "nationwide (United Airlines and Microsoft employees)",
  memberTerm: "members",
  behavioralHealthTerm:
    "behavioral health benefits, including mental health services",
  planSpecificIntro:
    "The United Airlines Microsoft (UA MS) Employee Plan is an employer-sponsored health insurance plan providing coverage to employees of United Airlines and Microsoft. This plan typically includes behavioral health benefits that may cover TMS therapy when medical necessity criteria are met. Because this is an employer-sponsored plan, coverage for TMS, accelerated TMS protocols, and other advanced depression treatments depends on the specific plan design, the underlying insurance network, and documented prior treatment history.",
  officialResourceUrl: "https://www.uabenefits.com/",
  officialResourceLabel: "United Airlines benefits portal",
};

export const UaMsEmployeePlanInsurance = () => (
  <InsurancePageTemplate config={config} />
);
export default UaMsEmployeePlanInsurance;
